var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4735 8.4401C10.325 5.45544 6.23577 5.2945 7.22334 0.956511C7.29649 0.634636 6.95267 0.385915 6.67469 0.554168C4.01923 2.11965 2.10992 5.25793 3.71198 9.36914C3.84366 9.70565 3.44863 10.0202 3.16333 9.80075C1.83926 8.79855 1.70026 7.35743 1.81731 6.32596C1.8612 5.94557 1.36376 5.76268 1.15161 6.07724C0.654172 6.83804 0.149414 8.06701 0.149414 9.91779C0.427397 14.0144 3.88755 15.2726 5.13116 15.4336C6.90878 15.6603 8.83271 15.3311 10.2153 14.0656C11.7369 12.6537 12.2929 10.4006 11.4735 8.4401ZM4.68492 12.1197C5.73833 11.8637 6.27966 11.1029 6.42597 10.4299C6.66738 9.38377 5.7237 8.35963 6.36013 6.70636C6.60154 8.07433 8.75224 8.93022 8.75224 10.4226C8.81077 12.2733 6.80637 13.8608 4.68492 12.1197Z",
    fill: "url(#paint0_linear_8791_12097)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4735 8.4401C10.325 5.45544 6.23577 5.2945 7.22334 0.956511C7.29649 0.634636 6.95267 0.385915 6.67469 0.554168C4.01923 2.11965 2.10992 5.25793 3.71198 9.36914C3.84366 9.70565 3.44863 10.0202 3.16333 9.80075C1.83926 8.79855 1.70026 7.35743 1.81731 6.32596C1.8612 5.94557 1.36376 5.76268 1.15161 6.07724C0.654172 6.83804 0.149414 8.06701 0.149414 9.91779C0.427397 14.0144 3.88755 15.2726 5.13116 15.4336C6.90878 15.6603 8.83271 15.3311 10.2153 14.0656C11.7369 12.6537 12.2929 10.4006 11.4735 8.4401ZM4.68492 12.1197C5.73833 11.8637 6.27966 11.1029 6.42597 10.4299C6.66738 9.38377 5.7237 8.35963 6.36013 6.70636C6.60154 8.07433 8.75224 8.93022 8.75224 10.4226C8.81077 12.2733 6.80637 13.8608 4.68492 12.1197Z",
    fill: "url(#paint1_linear_8791_12097)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8791_12097",
    x1: 6.00033,
    y1: 4.40061,
    x2: 6.00033,
    y2: 27.3167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B0CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007283"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8791_12097",
    x1: 6.00033,
    y1: 4.40061,
    x2: 6.00033,
    y2: 27.3167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B0CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007283"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.54edda07eb1963869b5da12973cdf978.svg";
export { ForwardRef as ReactComponent };